import styled from 'styled-components';

export const GridCellWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: repeat(auto-fill, 50%);

  ${GridCellWrapper} {
    border-bottom: 1px solid ${({ theme }) => theme.navigation.borderColor};
  }

  /* mobile: 2 columns */
  ${GridCellWrapper}:nth-child(odd) {
    border-right: 1px solid ${({ theme }) => theme.navigation.borderColor};
  }

  /* tablet: 3 columns */
  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    grid-template-columns: repeat(auto-fill, 33.33%);
    border-left: 1px solid ${({ theme }) => theme.navigation.borderColor};

    ${GridCellWrapper}:nth-child(-n+3) {
      border-top: 1px solid ${({ theme }) => theme.navigation.borderColor};
    }

    ${GridCellWrapper}:nth-child(even) {
      border-right: 1px solid ${({ theme }) => theme.navigation.borderColor};
    }
  }

  /* desktop: 4 columns */
  @media (min-width: ${({ theme }) => theme.breakpoints.mediumLarge}px) {
    grid-template-columns: repeat(auto-fill, 25%);

    ${GridCellWrapper}:nth-child(-n+4) {
      border-top: 1px solid ${({ theme }) => theme.navigation.borderColor};
    }
  }
`;
